import { render, staticRenderFns } from "./expense_items_report.vue?vue&type=template&id=36dba220&scoped=true&"
import script from "./expense_items_report.vue?vue&type=script&lang=js&"
export * from "./expense_items_report.vue?vue&type=script&lang=js&"
import style0 from "./expense_items_report.vue?vue&type=style&index=0&id=36dba220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dba220",
  null
  
)

export default component.exports